export default {"src":"/_next/static/media/ra-time.15774369.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};